/**
 * Template registry for the canvas-based image editors.
 *
 *   key         — short identifier (used for localStorage scope)
 *   label       — Thai display label
 *   src         — /public/ path to the base image
 *   width/height — native pixel dimensions of the base image
 *   defaults    — starting slot positions (native px). Subset:
 *                   company, date  (always present)
 *                   qr             (only for registration with a public link)
 *                   logo           (when company has a logo uploaded)
 *   hasQR       — whether the QR slot is part of this template
 *   dateLabel   — prefix label when rendering the date (e.g. "ในวันที่ ")
 */

export const SURVEY_REGISTRATION = {
  key:    'survey-registration',
  label:  'Service Registration',
  src:    '/survey-base.png',
  width:  1587,
  height: 2245,
  hasQR:  true,
  dateLabel: 'ในวันที่ ',
  defaults: {
    company: { x: 140,  y: 970,  fontPx: 70 },
    date:    { x: 370,  y: 1600, fontPx: 58 },
    qr:      { x: 470,  y: 1100, size:   340 },
    logo:    { x: 1180, y: 920,  w: 240, h: 240 },
  },
}

// Both PR main templates have a white speech-bubble area in the bottom-left.
// Defaults are calibrated to land within that area.
export const PR_MAIN_SQ = {
  key:    'pr-main-sq',
  label:  'PR Main · 1:1',
  src:    '/pr-main-sq.jpg',
  width:  1080,
  height: 1080,
  hasQR:  false,
  dateLabel: '',
  defaults: {
    company: { x: 40,  y: 870, fontPx: 38 },
    date:    { x: 40,  y: 922, fontPx: 30 },
    logo:    { x: 320, y: 870, w: 110, h: 110 },
  },
}

export const PR_MAIN_A4 = {
  key:    'pr-main-a4',
  label:  'PR Main · A4',
  src:    '/pr-main-a4.jpg',
  width:  1055,
  height: 1491,
  hasQR:  false,
  dateLabel: '',
  defaults: {
    company: { x: 38,  y: 1218, fontPx: 40 },
    date:    { x: 38,  y: 1278, fontPx: 32 },
    logo:    { x: 318, y: 1210, w: 120, h: 120 },
  },
}

// CST satisfaction-survey poster — A4. Only the QR slot is movable; the
// template artwork already has the brand/headline/etc. baked in.
export const CST_PROMOTE_A4 = {
  key:    'cst-promote-a4',
  label:  'CST QR · A4',
  src:    '/cst-promote-a4.png',
  width:  1055,
  height: 1491,
  hasQR:  true,
  dateLabel: '',
  defaults: {
    // QR slot lands inside the white "สแกน QR CODE" frame near the
    // center-left of the poster. Staff can drag/resize before saving.
    qr: { x: 88, y: 760, size: 280 },
  },
}

export const TEMPLATES = {
  [SURVEY_REGISTRATION.key]: SURVEY_REGISTRATION,
  [PR_MAIN_SQ.key]:           PR_MAIN_SQ,
  [PR_MAIN_A4.key]:           PR_MAIN_A4,
  [CST_PROMOTE_A4.key]:       CST_PROMOTE_A4,
}
